/**
 * Password Toggle Functionality
 * Shared script for showing/hiding password fields
 */

// Show/hide password toggle
window.togglePassword = function(inputId, btn) {
    var input = document.getElementById(inputId);
    var icon = btn.querySelector('i');
    if (input.type === "password") {
        input.type = "text";
        if (icon) {
            icon.classList.remove('fa-eye');
            icon.classList.add('fa-eye-slash');
        }
        // Change button background to blue when showing password
        btn.classList.add('btn-primary');
        btn.classList.remove('btn-outline-secondary');
    } else {
        input.type = "password";
        if (icon) {
            icon.classList.remove('fa-eye-slash');
            icon.classList.add('fa-eye');
        }
        // Restore button background to outline when hiding password
        btn.classList.remove('btn-primary');
        btn.classList.add('btn-outline-secondary');
    }
};

// Hide floating label when input has value or is focused (for password fields with toggle buttons)
document.addEventListener('DOMContentLoaded', function() {
    function toggleLabel(input, labelId) {
        var label = document.getElementById(labelId);
        if (!label) return;
        if (input.value.length > 0 || document.activeElement === input) {
            label.style.visibility = 'hidden';
        } else {
            label.style.visibility = 'visible';
        }
    }

    // Auto-detect password fields with labels and apply toggle behavior
    var passwordInputs = document.querySelectorAll('input[type="password"]');
    passwordInputs.forEach(function(input) {
        var labelId = input.id + '-label';
        var label = document.getElementById(labelId);
        
        if (label) {
            input.addEventListener('input', function() {
                toggleLabel(input, labelId);
            });
            input.addEventListener('focus', function() {
                toggleLabel(input, labelId);
            });
            input.addEventListener('blur', function() {
                toggleLabel(input, labelId);
            });
            // Initial state
            toggleLabel(input, labelId);
        }
    });
});
